package pl.decks.personal

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.HorizontalDividerStyle
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.loadFromLocalStorage
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import com.varabyte.kobweb.silk.theme.colors.saveToLocalStorage
import com.varabyte.kobweb.silk.theme.colors.systemPreference
import com.varabyte.kobweb.silk.theme.modifyStyleBase
import org.jetbrains.compose.web.css.CSSMediaQuery
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.StylePropertyValue
import pl.decks.personal.styles.GlobalStylesheet
import pl.decks.personal.styles.SiteLayout
import pl.decks.personal.site.BuildConfig
import pl.decks.posthog.client.PostHogClient
import pl.decks.posthog.config.Persistence
import pl.decks.posthog.config.PersonProfiles
import pl.decks.posthog.config.PostHogConfig

private const val COLOR_MODE_KEY = "pl-decks-personal-site:colorMode"
private const val ENV_KEY = "env"

@InitSilk
fun initColorMode(ctx: InitSilkContext) {
    ctx.config.initialColorMode = ColorMode.loadFromLocalStorage(COLOR_MODE_KEY) ?: ColorMode.systemPreference
}

@InitSilk
fun initStyles(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyle("html") {
        cssRule(CSSMediaQuery.MediaFeature("prefers-reduced-motion", StylePropertyValue("no-preference"))) {
            Modifier.scrollBehavior(ScrollBehavior.Smooth)
        }
    }
    ctx.theme.modifyStyleBase(HorizontalDividerStyle) {
        Modifier
            .fillMaxWidth()
            .border(
                width = SiteLayout.Line.Hairline,
                style = LineStyle.Solid,
                color = colorMode.toPalette().border,
            )
    }
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
        val colorMode = ColorMode.current
        LaunchedEffect(Unit) {
            PostHogClient.init(
                BuildConfig.phKey, config = PostHogConfig(
                    apiHost = "https://eu.i.posthog.com",
                    defaults = "2026-05-30",
                    persistence = Persistence.MEMORY,
                    personProfiles = PersonProfiles.IDENTIFIED_ONLY,
                )
            )
            PostHogClient.register(ENV_KEY to BuildConfig.phEnv.uppercase())
        }
        LaunchedEffect(colorMode) {
            colorMode.saveToLocalStorage(COLOR_MODE_KEY)
        }
        Surface(
            modifier =
                SmoothColorStyle.toModifier()
                    .then(GlobalStylesheet.Screen.toModifier())
                    .then(GlobalStylesheet.Text.toModifier())
        ) {
            content()
        }
    }
}
